import { render, staticRenderFns } from "./image-wall.vue?vue&type=template&id=63a9b3e4&scoped=true&"
import script from "./image-wall.vue?vue&type=script&lang=js&"
export * from "./image-wall.vue?vue&type=script&lang=js&"
import style0 from "./image-wall.vue?vue&type=style&index=0&id=63a9b3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9b3e4",
  null
  
)

export default component.exports